import { Component, OnDestroy, OnInit } from '@angular/core';
import { InstantSearchService } from '../../services/instant-search.service';
import { debounceTime, filter, map, Subscription } from 'rxjs';
import { InstantSearch, UiState, Widget } from 'instantsearch.js';
import { FormControl, FormGroup } from '@angular/forms';
import connectSearchBox from 'instantsearch.js/es/connectors/search-box/connectSearchBox';
import { Location } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { materialSymbols } from '../../../../../shared/constants/material-symbols';


@Component({
    selector: 'app-autocomplete-search-box',
    templateUrl: './autocomplete-search-box.component.html',
    styleUrl: './autocomplete-search-box.component.scss',
    standalone: false
})
export class AutocompleteSearchBoxComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  widgets: Widget[] = [];
  searchPath: string = '/search';
  isOnGlobalSearchPage: boolean = false;

  isMenuOpen: boolean = false;
  searchIcon: string = materialSymbols.search;


  refineFn: (query: string) => void = () => {};
  queryText: string = '';

  searchFormGroup: FormGroup = new FormGroup({
    searchInput: new FormControl('')
  });

  get searchInputControl(): FormControl {
    return this.searchFormGroup.get('searchInput') as FormControl;
  }

  constructor(
    private instantSearchService: InstantSearchService,
    private location: Location,
    private router: Router

  ) { }


  ngOnInit(): void {
    this.setupInstantSearchService();

    // Set initial state of whether we are on the global search page or not,
    //  and subscribe to router events to update this state on navigation
    this.isOnGlobalSearchPage = this.location.path().startsWith(this.searchPath);
    this.setupRouterSubscription();

    this.setupSearchFormSubscription();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();

    console.log('AutocompleteSearchBoxComponent: Removing InstantSearch widgets');
    this.instantSearchService.instance?.removeWidgets(this.widgets);
  }

  setupRouterSubscription(): void {
    this.subscriptions.add(this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
          this.setMenuOpenState(false); // Close the menu on navigation
          this.isOnGlobalSearchPage = event.url.startsWith(this.searchPath);
      }
    }));
  }

  setupInstantSearchService(): void {
    this.subscriptions.add(this.instantSearchService.instanceSubject$.pipe(
      filter((instance) => instance !== null),
      map((instance) => instance as InstantSearch<UiState, UiState>)
    ).subscribe({
      next: (instantSearchInstance: InstantSearch<UiState, UiState>) => {
        this.setupSearchBoxWidget(instantSearchInstance);

      }
    }));
  }

  setupSearchBoxWidget(instantSearchInstance: InstantSearch<UiState, UiState>): void {
    const customSearchBox = connectSearchBox(
      ({ query, refine, clear, widgetParams }, isFirstRender) => {
        //console.log('SearchBox render', { query, refine, clear, widgetParams });
        if (isFirstRender) {
          this.refineFn = refine;
        }

      }
    );

    const searchBoxWidget = customSearchBox({});
    instantSearchInstance.addWidgets([
      searchBoxWidget,
    ]);
    this.widgets.push(searchBoxWidget);
  }



  setupSearchFormSubscription(): void {
    this.subscriptions.add(this.searchInputControl.valueChanges.pipe(
      debounceTime(500)
    )
    .subscribe({
      next: (value: any) => {

        console.log('Autocomplete search input changed:', value);

        this.refineFn(value);
        this.queryText = value;
        this.setMenuOpenState(true);
      }
    }));
  }

  onSearchInputFocus() {
    this.setMenuOpenState(true);
  }

  onSearchInputBlur() {
    this.setMenuOpenState(false);
  }

  setMenuOpenState(hasFocus: boolean) {
    this.isMenuOpen = hasFocus && this.queryText.trim().length > 0;
  }

  handleItemSelected(item: any) {
    const value = item?.projectDesignationForDisplay || '';
    // update input field
    this.searchInputControl.setValue(value, { emitEvent: false });
    // keep internal state in sync
    this.queryText = value;
    // close menu
    this.setMenuOpenState(false);
  }
}
